// Thai copy for /on-demand-ftp (polite, "คุณ", not stiff), translated from copy.en.ts. Same shape (checked by
// copy.test.ts). "FTP ตามต้องการ"; "ตัวอัปโหลดบนเว็บ" for the web uploader.
// The uploader's and FileZilla's own labels are in English, so «labels» are quoted as the app shows them.
import type { OnDemandFtpCopy } from "./copy.en";

const th: OnDemandFtpCopy = {
  seo: {
    title: "FTP ตามต้องการทำงานอย่างไร | Photohawk",
    description:
      "หากจำเป็นต้องใช้ FTP สมาชิกในพื้นที่ทำงานทุกแพ็กเกจเริ่มเซิร์ฟเวอร์ FTP ของ Photohawk เป็นของตัวเองได้จากตัวอัปโหลดบนเว็บ พร้อมใช้ในประมาณ 30 วินาที ด้วยที่อยู่ส่วนตัวที่ไม่มีวันเปลี่ยน และจะปิดเองเมื่อไม่มีการใช้งานครบหนึ่งชั่วโมง",
  },
  hero: {
    badge: "ทุกแพ็กเกจ",
    eyebrow: "ใช้งานได้แล้ววันนี้",
    title: "FTP ตามต้องการทำงานอย่างไร",
    subtitle:
      "หากจำเป็นต้องใช้ FTP คุณเริ่มเซิร์ฟเวอร์ FTP ของตัวเองจากตัวอัปโหลดบนเว็บได้ทุกเมื่อที่ต้องการ พร้อมใช้ในประมาณ 30 วินาที และปิดเองเมื่อคุณใช้งานเสร็จ",
  },
  before: {
    title: "ก่อนเริ่ม: ตัวอัปโหลดบนเว็บเร็วกว่า",
    body: "ตัวอัปโหลดบนเว็บคือวิธีอัปโหลดมาตรฐาน ใช้ได้ทุกแพ็กเกจ",
    points: [
      { id: "parallel", text: "ส่งภาพได้ทีละหลายภาพพร้อมกัน มากกว่าโปรแกรม FTP อย่าง FileZilla (ค่าเริ่มต้นส่งครั้งละ 2 ไฟล์ และสูงสุดไม่เกิน 10 ไฟล์) อยู่มาก" },
      { id: "adaptive", text: "ปรับตัวตามการเชื่อมต่อของคุณ เพื่อใช้ได้อย่างเต็มที่" },
      { id: "live", text: "ภาพพรีวิวขึ้นก่อน แกลเลอรีของคุณจึงออนไลน์ได้ในไม่กี่นาที ขณะที่ไฟล์ต้นฉบับทยอยตามมา" },
      { id: "resume", text: "หากการเชื่อมต่อหลุด ระบบจะอัปโหลดต่อเอง" },
    ],
    button: "เปิดตัวอัปโหลดบนเว็บ",
    link: "ดูตัวอัปโหลดบนเว็บใหม่",
  },
  what: {
    heading: "เซิร์ฟเวอร์ FTP ของคุณเอง เมื่อคุณต้องการ",
    body: "สมาชิกในพื้นที่ทำงานทุกแพ็กเกจเริ่มเซิร์ฟเวอร์ FTP ของตัวเองได้จากตัวอัปโหลดบนเว็บ แต่ละคนจะได้เซิร์ฟเวอร์ของตัวเอง ด้วยที่อยู่ส่วนตัวที่ไม่มีวันเปลี่ยน คุณจึงตั้งค่าโปรแกรม FTP เพียงครั้งเดียว เมื่อไม่ได้ใช้งานก็ไม่มีอะไรทำงานค้างไว้ เซิร์ฟเวอร์จะปิดเองเมื่อไม่มีการใช้งานครบหนึ่งชั่วโมง",
    date: "1 พฤศจิกายน 2026",
    closing: "เซิร์ฟเวอร์ FTP ส่วนกลางที่เปิดตลอดเวลาของเราจะปิดในวันที่ 1 พฤศจิกายน 2026 หากตอนนี้คุณใช้อยู่ ให้เริ่มเซิร์ฟเวอร์ของคุณเอง แล้วเปลี่ยนโฮสต์ในโปรแกรม FTP",
  },
  steps: {
    heading: "วิธีการทำงาน",
    subtitle: "ครั้งแรกมีสี่ขั้นตอน หลังจากนั้นแค่เริ่มเซิร์ฟเวอร์แล้วอัปโหลด",
    items: [
      { id: "open", title: "เปิดตัวอัปโหลดบนเว็บ", body: "ไปที่ `upload.photohawk.com` แล้วลงชื่อเข้าใช้ หรือเปิดแท็บ «Upload» ของแกลเลอรี" },
      { id: "start", title: "เริ่มเซิร์ฟเวอร์ของคุณ", body: "คลิก «FTP server» ที่ด้านบน แล้วคลิก «Start FTP server» เซิร์ฟเวอร์จะพร้อมใช้ในประมาณ 30 วินาที" },
      { id: "connect", title: "คัดลอกที่อยู่และข้อมูลเข้าสู่ระบบไปใส่ในโปรแกรม FTP", body: "ที่อยู่ของคุณ พอร์ต 21 อีเมลและรหัสผ่าน Photohawk ของคุณ ที่อยู่นี้ไม่มีวันเปลี่ยน" },
      { id: "upload", title: "อัปโหลด", body: "ใส่ภาพลงในโฟลเดอร์ของแกลเลอรี เซิร์ฟเวอร์จะปิดเองเมื่อไม่มีการอัปโหลดครบหนึ่งชั่วโมง" },
    ],
    button: "เริ่มเซิร์ฟเวอร์ FTP ของคุณ",
    buttonNote: "เปิดตัวอัปโหลดบนเว็บพร้อมเซิร์ฟเวอร์ FTP ที่พร้อมให้เริ่ม",
  },
  panel: {
    heading: "สิ่งที่คุณจะเห็น",
    body: "ทุกอย่างอยู่ในแผง «Your FTP server» ในตัวอัปโหลดบนเว็บ พร้อมปุ่มคัดลอกข้างข้อมูลแต่ละรายการ",
    points: [
      { id: "address", text: "ที่อยู่ของคุณ เช่น `swift-heron-4821.ftp.photohawk.com` เป็นของคุณตลอดไป คุณจึงตั้งค่าเพียงครั้งเดียว" },
      { id: "ip", text: "แผงยังแสดงที่อยู่ IP ของเซิร์ฟเวอร์ด้วย ที่อยู่ IP จะเปลี่ยนทุกครั้งที่คุณเริ่มเซิร์ฟเวอร์ จึงควรใช้ที่อยู่แทนเมื่อทำได้" },
      { id: "countdown", text: "นับถอยหลังจนถึงเวลาปิด พร้อมปุ่ม «Keep it running» และ «Stop»" },
    ],
    alt: "แผง “Your FTP server” แสดงสถานะ Ready ในยุโรป (ไอร์แลนด์) พร้อมโฮสต์ swift-heron-4821.ftp.photohawk.com ที่อยู่ IP พอร์ต 21 ชื่อผู้ใช้ alex@example.com โหมด Passive และ FTP ผ่าน TLS รวมถึงการนับถอยหลังพร้อมปุ่ม Keep it running และ Stop",
  },
  details: {
    heading: "ข้อมูลการเชื่อมต่อของคุณ",
    subtitle: "กรอกข้อมูลเหล่านี้ในโปรแกรม FTP",
    rows: [
      { id: "host", label: "โฮสต์", value: "ที่อยู่ของคุณ เช่น `swift-heron-4821.ftp.photohawk.com` (หรือที่อยู่ IP ที่แสดง)" },
      { id: "port", label: "พอร์ต", value: "21" },
      { id: "user", label: "ชื่อผู้ใช้", value: "อีเมล Photohawk ของคุณ" },
      { id: "password", label: "รหัสผ่าน", value: "รหัสผ่าน Photohawk ของคุณ หรือรหัสผ่าน FTP (ด้านล่าง)" },
      { id: "mode", label: "โหมดการโอน", value: "Passive" },
      { id: "encryption", label: "การเข้ารหัส", value: "FTP ธรรมดา หรือ FTPS (FTP แบบ explicit ผ่าน TLS) สำหรับ FTPS ให้ใช้ชื่อโฮสต์ ไม่ใช่ที่อยู่ IP" },
    ],
    switching: "เคยใช้ FTP ของ Photohawk มาก่อนใช่ไหม ชื่อผู้ใช้ รหัสผ่าน และโฟลเดอร์ยังเหมือนเดิม แค่เปลี่ยนโฮสต์เป็นที่อยู่ใหม่ของคุณ",
  },
  password: {
    heading: "รหัสผ่านสำหรับ FTP โดยเฉพาะ หากต้องการ",
    body: "แทนที่จะบันทึกรหัสผ่าน Photohawk ไว้ในโปรแกรม FTP ให้คลิก «Create FTP password» ในแผง รหัสผ่านนี้ใช้ได้เฉพาะกับเซิร์ฟเวอร์ FTP ของคุณ โดยใช้อีเมลของคุณเป็นชื่อผู้ใช้ คุณคัดลอก สร้างรหัสใหม่ (รหัสเก่าจะใช้ไม่ได้ภายในหนึ่งนาที) หรือลบทิ้งได้ทุกเมื่อ รหัสผ่าน Photohawk ของคุณก็ยังใช้ได้ตามเดิม",
  },
  folders: {
    heading: "โฟลเดอร์ของคุณ",
    body: "คุณจะเห็นโฟลเดอร์เดียวกับที่เคยเห็น:",
    path: "/Galleries/<gallery>/<collection>",
    points: [
      { id: "single", text: "แกลเลอรีที่มีคอลเลกชันเดียวจะเป็นแค่ `/Galleries/<gallery>`" },
      { id: "workspaces", text: "อัปโหลดไปยังพื้นที่ทำงานมากกว่าหนึ่งแห่งใช่ไหม แต่ละแห่งจะมีโฟลเดอร์ของตัวเอง และมีแกลเลอรีอยู่ข้างใน" },
      { id: "create", text: "สร้างแกลเลอรีและคอลเลกชันใน Photohawk ก่อน ภาพของคุณจะปรากฏในแกลเลอรีภายในไม่กี่อึดใจ เหมือนกับการใช้ตัวอัปโหลดบนเว็บ" },
    ],
  },
  off: {
    heading: "ปิดเองอัตโนมัติ",
    body: "เซิร์ฟเวอร์ของคุณจะปิดเองเมื่อไม่มีการใช้งานครบ 1 ชั่วโมง จึงไม่ต้องคอยจำ แผงจะแสดงการนับถอยหลัง",
    points: [
      { id: "keep", text: "«Keep it running» เริ่มนับถอยหลังใหม่โดยไม่ต้องอัปโหลดอะไร" },
      { id: "stop", text: "«Stop» ปิดเซิร์ฟเวอร์ทันทีเมื่อคุณใช้งานเสร็จ" },
      { id: "caps", text: "เพื่อความปลอดภัย เซิร์ฟเวอร์จะปิดเองหลังจากไม่มีการอัปโหลดครบ 12 ชั่วโมง และเปิดได้นานสุด 24 ชั่วโมง" },
      { id: "again", text: "เริ่มใหม่ได้ทุกเมื่อ ด้วยที่อยู่และข้อมูลเข้าสู่ระบบเดิม" },
    ],
  },
  regions: {
    heading: "ภูมิภาค",
    body: "เปิดเซิร์ฟเวอร์ของคุณได้ในยุโรป (ไอร์แลนด์) สหรัฐอเมริกาฝั่งตะวันออก (เวอร์จิเนียเหนือ) หรือเอเชียแปซิฟิก (มาเลเซีย) ระบบจะเลือกภูมิภาคที่ใกล้ที่สุดให้ และคุณเปลี่ยนได้ก่อนเริ่ม",
  },
  filezilla: {
    heading: "ตัวอย่าง: ตั้งค่า FileZilla",
    subtitle: "โปรแกรม FTP อื่นใช้การตั้งค่าเดียวกัน บางครั้งอาจใช้ชื่อต่างกันเล็กน้อย",
    steps: [
      { id: "site", text: "เปิด «File → Site Manager» แล้วคลิก «New site»" },
      { id: "protocol", text: "โปรโตคอล: «FTP – File Transfer Protocol»" },
      { id: "host", text: "โฮสต์: ที่อยู่ของคุณ เช่น `swift-heron-4821.ftp.photohawk.com` พอร์ต: `21`" },
      { id: "tls", text: "การเข้ารหัส: «Use explicit FTP over TLS if available»" },
      { id: "login", text: "ประเภทการเข้าสู่ระบบ: «Normal» ผู้ใช้: อีเมล Photohawk ของคุณ รหัสผ่าน: รหัสผ่าน FTP หรือรหัสผ่าน Photohawk ของคุณ" },
      { id: "passive", text: "ในแท็บ «Transfer Settings» ให้เลือก «Passive» คลิก «Connect» แล้วเปิด `Galleries`" },
    ],
    tip: "จะส่งโฟลเดอร์ใหญ่ใช่ไหม FileZilla ส่งครั้งละ 2 ไฟล์ตามค่าเริ่มต้น และสูงสุดไม่เกิน 10 ไฟล์ คุณเพิ่มการตั้งค่าการโอนพร้อมกันได้สูงสุด 10 («Settings → Transfers») หรือใช้ตัวอัปโหลดบนเว็บ ซึ่งส่งได้พร้อมกันมากกว่านั้นมาก",
  },
  trouble: {
    heading: "หากมีปัญหา",
    items: [
      { id: "connect", title: "เชื่อมต่อไม่ได้", body: "ตรวจดูว่าแผงแสดง «Ready» หรือไม่ หากเพิ่งสร้างชื่อโฮสต์ ให้ใช้ที่อยู่ IP ไปก่อนสักหนึ่งนาที" },
      { id: "listing", title: "เชื่อมต่อได้ แต่รายการโฟลเดอร์ค้าง", body: "เปิดโหมด Passive" },
      { id: "logins", title: "“Too many failed logins”", body: "รอ 15 นาที แล้วตรวจสอบชื่อผู้ใช้ (อีเมลของคุณ) และรหัสผ่าน" },
    ],
  },
  faq: {
    heading: "คำถามที่พบบ่อย",
    items: [
      {
        q: "ทำไมเซิร์ฟเวอร์ของฉันปิดไป",
        a: "เซิร์ฟเวอร์จะปิดเองเมื่อไม่มีการใช้งานครบหนึ่งชั่วโมง จึงไม่เปิดค้างไว้ตอนที่คุณไม่ได้ใช้ เริ่มใหม่ได้ทุกเมื่อ ที่อยู่และข้อมูลเข้าสู่ระบบยังเหมือนเดิม หากต้องการให้ทำงานต่อโดยไม่ต้องอัปโหลด ให้คลิก «Keep it running» นอกจากนี้เซิร์ฟเวอร์ยังปิดเองหลังจากไม่มีการอัปโหลดครบ 12 ชั่วโมง และเปิดได้นานสุด 24 ชั่วโมง",
      },
      {
        q: "สองคนเปิดเซิร์ฟเวอร์พร้อมกันได้ไหม",
        a: "ได้ ทุกคนในพื้นที่ทำงานของคุณเริ่มเซิร์ฟเวอร์ของตัวเองได้ คนละหนึ่งเครื่อง ด้วยที่อยู่ของตัวเอง มีเพียงคุณที่เข้าสู่ระบบเซิร์ฟเวอร์ของคุณได้",
      },
      {
        q: "ปลอดภัยไหม",
        a: "ปลอดภัย เมื่อใช้ FTPS (FTP ผ่าน TLS) กับชื่อโฮสต์ของคุณ การเชื่อมต่อจะเข้ารหัสด้วยใบรับรองที่เชื่อถือได้ เซิร์ฟเวอร์ของคุณรับเฉพาะข้อมูลเข้าสู่ระบบของคุณ และหากเข้าสู่ระบบไม่สำเร็จหลายครั้ง เซิร์ฟเวอร์จะบล็อกการเชื่อมต่อนั้นเป็นเวลา 15 นาที",
      },
      {
        q: "ต้องจ่ายเพิ่มไหม",
        a: "ไม่ต้อง เซิร์ฟเวอร์ FTP ของคุณเองรวมอยู่ในทุกแพ็กเกจ",
      },
      {
        q: "ใช้ได้ทุกแพ็กเกจไหม",
        a: "ได้ รวมถึง Lite ด้วย สำหรับการอัปโหลดทั่วไป ตัวอัปโหลดบนเว็บหรือ Photohawk Studio เร็วกว่า ส่วนเซิร์ฟเวอร์ FTP ของคุณเองพร้อมใช้เมื่อจำเป็นต้องใช้ FTP",
      },
      {
        q: "FTP ส่วนกลางแบบเดิมจะเป็นอย่างไร",
        a: "เซิร์ฟเวอร์ FTP ส่วนกลางที่เปิดตลอดเวลาจะปิดในวันที่ 1 พฤศจิกายน 2026 และยังใช้งานได้ตามปกติจนถึงวันนั้น หากต้องการใช้ FTP ต่อ ให้เริ่มเซิร์ฟเวอร์ของคุณเอง แล้วเปลี่ยนโฮสต์ในโปรแกรม FTP เป็นที่อยู่ใหม่ ชื่อผู้ใช้ รหัสผ่าน และโฟลเดอร์ยังเหมือนเดิม",
      },
    ],
  },
  cta: {
    heading: "พร้อมเมื่อคุณพร้อม",
    body: "สำหรับการอัปโหลดประจำวัน ให้ใช้ตัวอัปโหลดบนเว็บ เมื่อจำเป็นต้องใช้ FTP เซิร์ฟเวอร์ของคุณเองก็อยู่ห่างแค่คลิกเดียว",
    primary: "เปิดตัวอัปโหลดบนเว็บ",
    secondary: "เริ่มเซิร์ฟเวอร์ FTP ของคุณ",
  },
};

export default th;
